module.exports = __webpack_public_path__ + "img/river.685acc6d.svg";